import routes, { formatRoute } from 'PatientTravel/routes'
import { http } from '@/system/http'

const backendService = {
    async fetchOffice(postcode) {
        return http.get(routes.getOffice + postcode)
    },
    async fetchTypeOptions() {
        return http.get(routes.listTypes)
    },
    async fetchTreatmentSiteFilters() {
        return http.get(routes.listTreatmentSiteFilters)
    },
    async listTreatmentSites(data) {
        return http.post(routes.listTreatmentSites, data)
    },
    async getTreatmentSite(id) {
        const url = formatRoute(routes.getTreatmentSite, { id: id })
        return http.get(url)
    },
    async fetchClientAddresses(data) {
        return http.post(routes.listAddresses, data)
    },
    async storeRequisition(data) {
        return http.post(routes.storeRequisition, data)
    },
    async validateRequisition(data) {
        return http.post(routes.validateRequisition, data)
    },
    async getRequisition(requisitionNumber) {
        const url = formatRoute(
            routes.getRequisition,
            { requisitionNumber: requisitionNumber }
        )
        return http.get(url)
    },
    async cancelRequisition(requisitionNumber, direction, bookingId) {
        const url = formatRoute(routes.cancelRequisition, {
            requisitionNumber: requisitionNumber,
            direction: direction,
            bookingId: bookingId,
        })
        return http.delete(url)
    },
    async getPreferences() {
        return http.get(routes.preferences)
    },
    async setPreferences(data) {
        return http.post(routes.preferences, data)
    },
}

export default backendService
